module.exports = __webpack_public_path__ + "static/media/iphone-x.048e21ee.png";